var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-one-layout"},[_c('div',{staticStyle:{"display":"flex","width":"100vw"}},[_c('article',{staticStyle:{"width":"80vw","margin":"auto","text-align":"left","font-size":"1.3rem"}},[_c('h2',[_vm._v("Wynik został przesłany")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19bfb166","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SendResultStatus.vue
// module id = null
// module chunks = 